import React, { Component } from "react";
import { getAccessKeyParam } from "Utils";
import { connect } from "react-redux";
import { verifyPresentationAccessKey } from "Thunks";
import styles from "./Presentation.local.scss";
import NotFoundV2 from "../NotFound/NotFoundV2";
import _ from "i18n";
import {
  // fetchAuthUser,
  setLanguage,
  setAuthToken,
  // setAuth,
  // setExpiresIn,
  // setTokenCreatedAt
  setCurrentNavPage
} from "Actions";
import PresentationPage from "./PresentationPage";

class PresentationAccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uen: null,
      accessKey: null,
      isValid: false
    };
  }

  componentDidMount() {
    const { dispatch, location } = this.props;

    let { uen } = this.props.match.params;
    this.setState({ uen: uen });

    const accessKey = getAccessKeyParam(location);
    this.setState({ accessKey: accessKey });

    if (!uen || !accessKey) {
      return false;
    }

    dispatch(setCurrentNavPage("PRESENTATION_PAGE"));
    dispatch(setLanguage("fr"));
    dispatch(verifyPresentationAccessKey(uen, accessKey)).then(
      res => {
        this.setState({ isValid: true });

        dispatch(setAuthToken(res.value.access_token));
      },
      err => this.setState({ isValid: false })
    );
  }

  renderResult = () => {
    const { fetching, fetched, error, token } = this.props;
    const { isValid } = this.state;

    if (fetching && !isValid) {
      return (
        <div className={styles.ripple_loading_adapted}>
          <img src={"/img/Ripple-1s-150px.svg"} alt="" />
        </div>
      );
    }

    if (!fetching && error && !isValid) {
      return (
        <div>
          <img
            src={"/img/Logo-Tamtam.png"}
            alt={""}
            className={styles.logo_tamtam_error_page}
          />
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            subText={`${_(
              "accessDenied"
            )} : Le lien fourni a expiré ou non valide`}
            text={
              "Pour plus d'informations, merci de consulter votre gestionnaire."
            }
            buttonIgnored={true}
          />
        </div>
      );
    }

    if (fetched && isValid && token) {
      return <PresentationPage organizationUen={this.state.uen} />;
    }

    return false;
  };

  render() {
    return this.renderResult();
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.accessKey.fetching,
  fetched: state.accessKey.fetched,
  data: state.accessKey.data,
  error: state.accessKey.error,
  token: state.auth.token,
  presentation: state.presentation.data
});

export default connect(mapStateToProps)(PresentationAccess);



// WEBPACK FOOTER //
// ./src/components/Presentation/PresentationAccess.js